import type { Language, Locale } from '@packages/config';
import config from '@packages/config';

const extractLanguage = (locale: Locale): Language | undefined => {
  const language = locale.split('-')[0];
  return (config.i18n.languages as string[]).includes(language)
    ? (language as Language)
    : undefined;
};

/**
 * Extracts the two-letter language code from a locale string,
 * validated against the tenant's configured languages.
 * Falls back to the default locale's language if the given locale is not supported.
 *
 * @param locale - A locale string (e.g. 'de-DE', 'fr-CH').
 * @returns The language code if it is supported by the tenant, otherwise the default language.
 */
export const getLanguageFromLocale = (locale: Locale): Language =>
  extractLanguage(locale) ?? (extractLanguage(config.i18n.defaultLocale) as Language);
